import { VueHeadMixin, createHead } from '@unhead/vue';

const head = createHead();

export default {
    install(app) {
        app.use(head);
        // This mixin enables the use of Options API in vue 3
        app.mixin(VueHeadMixin);
    },
};
